import type { LocalAddressProvince } from '../hooks/useLocalAddressesProvinces';

/**
 * Maps a province description to its corresponding province code
 * @param provinces - Array of LocalAddressProvince objects
 * @param description - The province description (display name)
 * @returns The province code or undefined if not found
 */
export const getProvinceCodeFromDescription = (
  provinces: LocalAddressProvince[], 
  description: string
): string | undefined => {
  if (!description || !provinces.length) {
    return undefined;
  }
  
  const province = provinces.find(p => p.descr === description);
  return province?.provinceCode;
};

/**
 * Maps a province code to its corresponding description
 * @param provinces - Array of LocalAddressProvince objects
 * @param provinceCode - The province code
 * @returns The province description or undefined if not found
 */
export const getProvinceDescriptionFromCode = (
  provinces: LocalAddressProvince[], 
  provinceCode: string
): string | undefined => {
  if (!provinceCode || !provinces.length) {
    return undefined;
  }
  
  const province = provinces.find(p => p.provinceCode === provinceCode);
  return province?.descr;
};